import { takeLatest } from 'redux-saga/effects';

import {
    setCookie,
    deleteCookie,
} from 'helpers/CookiesHelpers';

import Cookies from '../constants/Cookies';

import {
    INIT_CMP_APP,
} from '../reduxModules/ConsentManagementPlatform';

export function callAction() {
    Cookies.forEach((cookiesGroup) => {
        cookiesGroup.cookies.forEach((cookie) => {
            if (document.cookie.indexOf(cookie.id) !== -1) {
                return;
            }
            cookie.cookiesNames.forEach((cookieName) => {
                deleteCookie(cookieName, 0);
            });
        });
    });

    if (document.cookie.indexOf('GOOGLE_ANALYTICS') === -1) {
        const matches = document.cookie.match(/_ga_(.+?)=/);
        if (matches && matches.length > 1) {
            const gaContainerId = matches[1];
            deleteCookie(`_ga_${gaContainerId}`, 0);
            deleteCookie(`_gac_gb_${gaContainerId}`, 0);
            deleteCookie(`_gac_${gaContainerId}`, 0);
        }
    }

    if (document.cookie.indexOf('FACEBOOK_PIXEL') === -1) {
        const fbmCookieMatch = document.cookie.match(/(fbm_\d+)=/);
        const fbsrCookieMatch = document.cookie.match(/(fbsr_\d+)=/);
        let fbmCookie = '';
        let fbsrCookie = '';
        const matchIndex = 1;
        if (fbmCookieMatch && fbmCookieMatch.length >= 2) {
            fbmCookie = fbmCookieMatch[matchIndex];
        }
        if (fbsrCookieMatch && fbsrCookieMatch.length >= 2) {
            fbsrCookie = fbsrCookieMatch[matchIndex];
        }
        setCookie(fbmCookie, 0, -1);
        setCookie(fbsrCookie, 0, -1);
    }
}

export function* watch() {
    yield takeLatest(INIT_CMP_APP, callAction);
}
